import { useRef, useState } from "react";
import axios from "axios";
import { X, Upload } from "lucide-react";

const LUNI = ["Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie", "Iulie",
  "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie"];

export const MoveToMonthModal = ({ api, onClose, onDone, showToast }) => {
  const [month, setMonth] = useState(12);
  const [year, setYear] = useState(2025);
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const inputRef = useRef(null);

  const run = async () => {
    if (!file) return;
    setBusy(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const r = await axios.post(`${api}/clients/move-to-month-from-excel`, form, {
        params: { month, year }, headers: { "Content-Type": "multipart/form-data" },
      });
      setResult(r.data);
      onDone();
    } catch (err) {
      showToast(err.response?.data?.detail || "Eroare la procesare", "err");
    } finally { setBusy(false); }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal modal-sm" onClick={(e) => e.stopPropagation()} data-testid="move-month-modal">
        <div className="modal-header">
          <div className="modal-title">Mută / adaugă clienți în lună</div>
          <button className="icon-btn" data-testid="move-month-close-x" onClick={onClose}><X size={18} /></button>
        </div>
        <div className="modal-body">
          {!result ? (
            <>
              <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
                <select data-testid="move-month-select" value={month} onChange={(e) => setMonth(+e.target.value)}>
                  {LUNI.map((l, i) => <option key={l} value={i + 1}>{l}</option>)}
                </select>
                <input data-testid="move-year-input" type="number" value={year} style={{ width: 90 }}
                  onChange={(e) => setYear(+e.target.value)} />
              </div>
              <button data-testid="move-pick-file-btn" className="btn btn-ghost" onClick={() => inputRef.current?.click()}>
                <Upload size={15} /> {file ? file.name : "Alege fișier Excel"}
              </button>
              <input ref={inputRef} type="file" accept=".xlsx,.xls" data-testid="move-file-input" style={{ display: "none" }}
                onChange={(e) => { setFile(e.target.files?.[0] || null); e.target.value = ""; }} />
              <p className="import-help">
                Clienții găsiți (<b>cod DEG</b>, <b>nume + adresă</b> sau <b>nume + telefon</b>) sunt mutați în luna aleasă, păstrând ziua.
                Cei care nu există sunt <b>adăugați</b>. Se face backup automat înainte.
              </p>
            </>
          ) : (
            <div className="import-stats" data-testid="move-result">
              <div className="istat"><div className="istat-lbl">Mutați</div><div className="istat-val soon" data-testid="move-result-moved">{result.moved}</div></div>
              <div className="istat"><div className="istat-lbl">Adăugați</div><div className="istat-val ok" data-testid="move-result-inserted">{result.inserted}</div></div>
              <div className="istat"><div className="istat-lbl">Deja în lună</div><div className="istat-val muted-v" data-testid="move-result-already">{result.already}</div></div>
            </div>
          )}
        </div>
        <div className="modal-footer">
          {!result ? (
            <button data-testid="move-run-btn" className="btn btn-primary" disabled={!file || busy} onClick={run}>
              {busy ? "Se procesează…" : "Aplică"}
            </button>
          ) : (
            <button data-testid="move-done-btn" className="btn btn-primary" onClick={onClose}>Am înțeles</button>
          )}
        </div>
      </div>
    </div>
  );
};
